<template>
    <div :class="`grid-outer grid-outer-${section} grid-outer-index-${index}`" v-for="(item, index) in json" :key="`gridouter${index}`">
        <Grid :filtersLinkouts="filtersLinkouts" :paginate="paginate" :type="type" :section="section" :outerIndex="index" :label="(type === 'base') ? item?.gridSectionHeader?.[0]?.title : null" :json="getJson(item)"  />
    </div>
</template>
<script>
import Grid from "@/components/blocks/Grid.vue";
export default {
    name: "GridOuterBlock",
    components: {
        Grid
    },
    data() {
        return {

        }
    },
    props: {
        json: {
            type: Array,
            required: true,
            default: null,
        },
        filtersLinkouts: {
            type: Array,
            required: false,
            default: null,
        },
        type: {
            type: String,
            required: false,
            default: 'base',
        },
        section: {
            type: String,
            required: true,
        },
        paginate: {
            type: Number,
            required: false,
            default: null,
        },
    },
    computed: {

    },
    mounted() {

    },
    beforeUnmount() {

    },
    methods: {
        getJson(item) {
            if (this.type === 'work') {
                return item.workGridItem
            } else {
                return item.gridItem
            }
        }
    }
}
</script>
